export const useMicrositeStore = defineStore('micrositeStore', {
    state: () => ({
        microsite: {},
        navigation: [],
        globalTheme: '',
    }),
    getters: {
        loadedMicrosite(): boolean {
            return !isEmpty(this.microsite)
        },
        isMicrosite(): boolean {
            // If we've already initialised a microsite entry, consider this a microsite
            if (!isEmpty(this.microsite)) return true

            const { uri, microsites } = storeToRefs(useGlobalStore())

            // if the current uri starts with any of the microsite uris, we are in a microsite
            return !!microsites.value.find(microsite => uri.value === microsite.uri || uri.value.startsWith(microsite.uri + '/'))
        },
        micrositeSlug(): string|null {
            const { uri } = storeToRefs(useGlobalStore())

            // the microsite slug is the first segment of the uri, if it matches a known microsite
            const segments = uri.value.split('/').filter(Boolean)
            const globalStore = useGlobalStore()
            const { microsites } = storeToRefs(globalStore)
            const match = microsites.value.find((m: any) => m?.uri === segments[0])

            return match ? match.uri : null
        },
    },
    actions: {
        async loadMicrosite(uri, options?: { routeQuery?: Record<string, any> }) {
            const { cmsQuery } = useGraphQL()

            const { data } = await cmsQuery({
                uri: `page-data/page/${uri}`,
                key: `page-${uri}`,
                routeQuery: options?.routeQuery ?? null,
            })
        
            this.initMicrosite(data.value.data.entry)
        },
        initMicrosite(entry) {
            this.microsite = entry?.__typename === 'ds_MicrositeHomepage_Entry' ? entry : get(entry, 'ancestors[0]', {})

            this.navigation = get(this.microsite, 'children', [])

            // set the theme
            const colorTheme = get(this.microsite, 'colorTheme', '')
            if (!isEmpty(colorTheme)) {
                this.globalTheme = colorTheme
            }
        },

    }
})
